// Web stub for react-native-track-player.
// react-native-track-player is native-only; LockScreenControls.js already
// guards every call with `if (Platform.OS === 'web') return;` so none of
// these are ever invoked in the browser.
const noop = () => Promise.resolve();
const TrackPlayer = {
  setupPlayer: noop,
  updateOptions: noop,
  add: noop,
  play: noop,
  pause: noop,
  stop: noop,
  reset: noop,
  setRepeatMode: noop,
  getPlaybackState: () => Promise.resolve({ state: 'none' }),
  updateNowPlayingMetadata: noop,
  addEventListener: () => ({ remove: noop }),
  registerPlaybackService: noop,
};

module.exports = TrackPlayer;
module.exports.default = TrackPlayer;
module.exports.Capability = {};
module.exports.Event = {};
module.exports.RepeatMode = {};
module.exports.State = {};
